export default [
  {
    feature: 'Professional dashboard',
    free: true,
    middle: true,
    premium: true
  },
  {
    feature: 'Emailing service',
    free: true,
    middle: true,
    premium: true
  },
  {
    feature: 'Workorder management',
    free: true,
    middle: true,
    premium: true
  },
  {
    feature: 'Accept payments',
    free: false,
    middle: true,
    premium: true
  },
  {
    feature: 'Store documents',
    free: false,
    middle: true,
    premium: true
  },
  {
    feature: 'Downloadable applications',
    free: false,
    middle: true,
    premium: true
  },
  {
    feature: 'Premium messaging service',
    free: false,
    middle: false,
    premium: true
  },
  {
    feature: '24/7 Premium support',
    free: false,
    middle: false,
    premium: true
  },
  {
    feature: 'Itemized expense tracking',
    free: false,
    middle: false,
    premium: true
  }
];
